import React, { useState, useEffect, useMemo } from 'react'
import Card from 'react-bootstrap/Card';
import ReactDataTableBootstrap from '../../Components/ReactDataTableBootstrap/ReactDataTableBootstrap';
import Controllers from '../../Api/Controllers';
import Helpers from '../../Components/Helpers/Helpers';
import { toast } from 'react-toastify'
import FormCustom from '../../Components/Form/FormCustom';
import Select from '../../Components/Form/Select';
import Button from 'react-bootstrap/esm/Button';

const CustomersPromo = _ => {
    const [isProcessing, setIsProccesing] = useState(false)
    const [rows, setRows] = useState([])
    const [promoSelected, setPromoSelected] = useState(-1)
    const [promos, setPromos] = useState([])

    const handleSubmit = _ => {
        setIsProccesing(true)
        Controllers.customers.report_promo_customers({
            p_key_promo: promoSelected === -1 ? '' : promoSelected
        }).then(res => {
            setRows(res.data)
        }).catch(req => Helpers.promise.catch({ req, toast }))
            .finally(() => {
                setIsProccesing(false)
            })
    }

    useEffect(_ => {
        Controllers.product.get_promos().then(res => {
            res.data.unshift({
                key_product: -1,
                name_product: 'TODOS'
            })
            setPromos(res.data)
        }).catch(req => Helpers.promise.catch({ req, toast }))
    }, [])

    const cboPromo = useMemo(() => {
        if (promoSelected === -1) {
            return {
                label: 'TODOS',
                value: -1
            }
        }

        let finded = promos.find(t => promoSelected === t.key_product)

        if (!finded) {
            return ''
        }
        return {
            label: finded.key_product + ' - ' + finded.name_product,
            value: finded.key_product
        }
    }, [promoSelected, promos])

    const dtRows = useMemo(() => {
        return <ReactDataTableBootstrap
            head={[
                [
                    { name: 'id_customers', text: 'ID' },
                    { name: 'full_name_customers', text: 'Nombres' },
                    { name: 'name_product', text: 'Promo', align: 'center' },
                    { name: 'points', text: 'Puntos Promo', align: 'center' },
                    {
                        name: 'dispatch', text: 'Estado', align: 'center', render: r => {
                            return <div className={'badge badge-' + (parseInt(r.dispatch) === 1 ? 'success' : 'info')}>
                                {parseInt(r.dispatch) === 1 ? 'ENTREGADO' : 'PENDIENTE'}
                            </div>
                        }
                    },
                    { name: 'date_pay', text: 'Fecha Entrega', align: 'center' },
                    {
                        name: 'name_branch_office', text: 'Sucursal', align: 'center', render: r => {
                            if (isNaN(parseInt(r.id_sale))) {
                                return '';
                            }

                            return `${r.key_branch_office} - ${r.name_branch_office}`
                        }
                    },
                    {
                        name: 'name_period', text: 'Periodo', align: 'center', render: r => {
                            if (isNaN(parseInt(r.id_sale))) {
                                return '';
                            }

                            return `${r.code_period} - ${r.name_period}`
                        }
                    },
                    { name: 'id_sale', text: 'Id Venta', align: 'center' },
                    {
                        name: 'sponsor_received', text: '¿Cobró Sponsor?', align: 'center', render: r => {
                            if (isNaN(parseInt(r.id_sale))) {
                                return '';
                            }

                            return <div className={'badge badge-' + (parseInt(r.sponsor_received) === 1 ? 'success' : 'info')}>
                                {parseInt(r.sponsor_received) === 1 ? 'SI' : 'NO'}
                            </div>
                        }
                    },
                    { name: 'full_name_sponsor', text: 'Sponsor', align: 'center' },
                    { name: 'point_current_customers', text: 'Puntos Alcanzados', align: 'center' },
                    { name: 'calculate_points', text: '¿Alcanzó Puntos?', align: 'center', render: r => {
                        return <div className={'badge badge-' + (parseInt(r.point_current_customers) >= parseInt(r.points)  ? 'success' : 'warning')}>
                            {parseInt(r.point_current_customers) >= parseInt(r.points) ? 'SI' : 'NO'}
                        </div>
                    } },
                ],
            ]}
            rows={rows}
            pageLength={100}
            isProcessing={isProcessing}
        />
    }, [rows, isProcessing])

    return <>
        <Card>
            <Card.Header className="justify-content-between">
                <span>Clientes Promos</span>
            </Card.Header>
            <Card.Body>
                <FormCustom viewSubmit={false}>
                    <Select
                        text="Promos"
                        classNameParent="col-12 mb-4"
                        options={promos.map(p => {
                            return {
                                label: p.key_product === -1 ? 'TODOS' : p.key_product + ' - ' + p.name_product,
                                value: p.key_product
                            }
                        })}
                        onChange={e => setPromoSelected(e.value)}
                        append={[
                            <Button onClick={handleSubmit}>
                                <i className="fa fa-search"></i>
                            </Button>
                        ]}
                        value={cboPromo}
                    />
                </FormCustom>
                {dtRows}
            </Card.Body>
        </Card>
    </>
}

export default CustomersPromo